var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return Object.keys(_vm.variants).length
    ? _c("div", { staticClass: "dropdown" }, [
        _c(
          "a",
          {
            staticClass:
              "btn btn-default btn-bold btn-upper btn-font-sm dropdown-toggle",
            attrs: { href: "#", role: "button", "data-toggle": "dropdown" },
          },
          [
            _vm._v(
              "\n        " +
                _vm._s((_vm.variants[_vm.selectedIndex] || {}).text) +
                "\n    "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "dropdown-menu" },
          _vm._l(_vm.variants, function (variant, index) {
            return _c(
              "a",
              {
                key: index,
                staticClass: "dropdown-item",
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.onClick(index)
                  },
                },
              },
              [_vm._v("\n            " + _vm._s(variant.text) + "\n        ")]
            )
          }),
          0
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }